<!--设置各列数据对应关系-->
<template>
  <div class="page-container">
    <Header></Header>

    <div class="main-layout">
      <div class="sidebar">
        <MenuList></MenuList>
      </div>

      <div class="content">
        <!-- 页面标题 -->
        <div class="page-header">
          <div class="page-title">
            <i class="el-icon-setting"></i>设置领表条件及可填写列
          </div>
          <div class="page-description">
            <p>此表预计可导入 <span class="highlight">{{dataList.length}}条</span> 数据，请按照步骤提示填写下面的内容</p>
          </div>
        </div>

        <!-- 设置表单 -->
        <div class="setting-container">
          <!-- 步骤1：输入名称 -->
          <div class="step-section">
            <div class="step-header">
              <div class="step-number">1</div>
              <div class="step-title">请输入名称 <span class="required">*</span></div>
            </div>
            <div class="step-content">
              <div class="step-tip">
                <i class="el-icon-info"></i>
                领表人可以看到这个名字，建议是xxx核对表，方便填写人理解。
              </div>
              <el-input
                v-model="form_name"
                placeholder="输入表格名称,如学籍核对表,通讯地址核对表等"
                class="form-name-input"
              ></el-input>
            </div>
          </div>

          <!-- 步骤2：选择查询条件 -->
          <div class="step-section">
            <div class="step-header">
              <div class="step-number">2</div>
              <div class="step-title">选择查询条件 <span class="required">*</span></div>
            </div>
            <div class="step-content">
              <div class="step-tip warning">
                <i class="el-icon-warning"></i>
                请从左框中查询条件列(如姓名,身份证等,最多两个)选到右侧框中。必须选择每个人都有数据的列,否则部分人将无法查询。
              </div>
              <div class="transfer-wrapper">
                <el-transfer
                  target-order="push"
                  v-model="selectedSearchCondition"
                  :data="transferList"
                  :titles="['可选的列', '用于查询的列']"
                  class="custom-transfer"
                ></el-transfer>
              </div>

              <!-- 已选查询条件预览 -->
              <div v-if="selectedSearchCondition.length > 0" class="selected-preview">
                <div class="preview-title">
                  <i class="el-icon-document"></i>
                  您需要填表人领表时需要正确输入以下内容才可以领取表格:
                </div>
                <div class="preview-box">
                  <div v-if="selectedSearchCondition.length == 1" class="preview-item">
                    <div class="preview-label">{{selectedSearchCondition[0]}}</div>
                    <div class="preview-input">
                      <input placeholder="这里是输入的位置" readonly />
                    </div>
                  </div>
                  <div v-if="selectedSearchCondition.length == 2" class="preview-item">
                    <div class="preview-item-row">
                      <div class="preview-label">{{selectedSearchCondition[0]}}</div>
                      <div class="preview-input">
                        <input placeholder="这里是输入的位置" readonly />
                      </div>
                    </div>
                    <div class="preview-item-row">
                      <div class="preview-label">{{selectedSearchCondition[1]}}</div>
                      <div class="preview-input">
                        <input placeholder="这里是输入的位置" readonly />
                      </div>
                    </div>
                    <div class="preview-note">
                      <i class="el-icon-info"></i>查询条件先后顺序可通过调整选入到右侧框中的先后顺序进行调整
                    </div>
                  </div>
                  <div v-if="selectedSearchCondition.length > 2" class="preview-error">
                    <i class="el-icon-warning"></i>最多是2个查询条件,请重新选择！
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 步骤3：指定可填写列 -->
          <div class="step-section">
            <div class="step-header">
              <div class="step-number">3</div>
              <div class="step-title">请指定哪些列需要领表人填写或修改 <span class="required">*</span></div>
            </div>
            <div class="step-content">
              <div class="step-tip">
                <i class="el-icon-info"></i>
                请从需要填写的列或者需要修改的列选择到右侧列表中，
                <span class="text-danger">未选入右框的只能查看，不能修改或填写</span>
              </div>
              <div class="transfer-wrapper">
                <el-transfer
                  target-order="push"
                  v-model="selectedFields"
                  :data="transferList"
                  :titles="['可选的列', '可填可改的列']"
                  class="custom-transfer"
                ></el-transfer>
              </div>

              <!-- 已选可填写列预览 -->
              <div v-if="selectedFields.length > 0" class="selected-preview">
                <div class="preview-title">
                  <i class="el-icon-edit"></i>
                  您需要填表人修改的或补填的内容如下:
                </div>
                <div class="preview-box fields-box">
                  <div v-for="(item, index) in selectedFields" :key="index" class="field-item">
                    <div class="field-info">
                      <span class="field-name">{{item}}</span>
                      <span class="field-type-edit" @click="openEditFieldType(item)">
                        填写格式：<span class="field-type">{{getFieldType(item)}}</span>
                        <i class="el-icon-edit"></i>点我可更换格式
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 步骤4：补充说明 -->
          <div class="step-section">
            <div class="step-header">
              <div class="step-number">4</div>
              <div class="step-title">补充说明</div>
            </div>
            <div class="step-content">
              <el-input
                type="textarea"
                v-model="search_description"
                placeholder="输入查询说明,通知,注意事项等,会显示在查询界面首页,所有的人都一样."
                :rows="3"
              ></el-input>
            </div>
          </div>

          <!-- 提交按钮 -->
          <div class="submit-section">
            <el-button type="primary" size="medium" @click="nextStep" class="submit-btn">
              <i class="el-icon-check"></i>填写完毕，点我立即导入所有数据!
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 操作确认弹窗 -->
    <el-dialog
      title="操作确认"
      :visible.sync="setConditionConfirmVisible"
      width="40%"
      custom-class="custom-dialog">
      <div class="confirm-content">
        <i class="el-icon-warning"></i>
        填写人需要正确输入 <span class="highlight">{{selectedSearchCondition}}</span> 才能查到及填写表格，确定吗?
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setConditionConfirmVisible = false">取消</el-button>
        <el-button @click="nextStepAction()" type="primary">确定,立即导入</el-button>
      </div>
    </el-dialog>

    <!-- 修改数据列类型弹窗 -->
    <el-dialog
      title="修改需要填写的数据类型"
      :visible.sync="editFieldTypeDialogVisible"
      width="35%"
      custom-class="custom-dialog">
      <div class="field-type-edit-form">
        <div class="form-item">
          <span class="label">数据列名称：</span>
          <span class="value">{{selectedEditFieldName}}</span>
        </div>
        <div class="form-item">
          <span class="label">数据列类型：</span>
          <el-select v-model="selected_field_type" placeholder="请选择" class="type-select">
            <el-option v-for="item in field_type_options" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editFieldTypeDialogVisible = false">取消</el-button>
        <el-button @click="saveFieldTypeAction()" type="primary">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        username: '',
        form_name: '',
        dataList: [],
        headList: [],

        transferList: [],
        selectedSearchCondition: [],
        finalConditions: [],

        selectedCondition: '',

        input_pages: '1',
        import_data: '',

        show_public: false,
        is_public: '0',
        search_description: '',
        selected_column_names: '',
        message: '',

        setConditionConfirmVisible: false,

        form_id: '',

        selectedFields: [],
        editFieldTypeDialogVisible: false,
        selectedEditFieldName: '',
        field_type_options: [{
            name: '文本',
            description: '可以填写任意内容'
          },
          {
            name: '数字',
            description: '必须填写数字，可以含小数点，不能收集身份证号,身份证号会有字母，也不能用于收集手机号，手机号有固定长度'
          },
          {
            name: '身份证号',
            description: '只能填写身份证号码,长度为15位或18位，末尾X大写'
          },
          {
            name: '手机号',
            description: '只能填写手机号,长度为11位'
          },
          {
            name: '年月',
            description: '如出生年月，入党年月，参加工作年月等'
          },
          {
            name: '日期',
            description: '格式是年月日，如：1992-07-16'
          },
          {
            name: '日期时间',
            description: '格式是年月日时分，如：1992-07-16 09:10'
          },
          {
            name: '日期范围',
            description: '格式是xxxx年xx月xx日~xxxx年xx月xx日，如工期、工作时间等'
          },
          {
            name: '图片',
            description: '上传一张图片'
          },
          {
            name: '签名',
            description: '手写签名，主要用于书面确认场景.'
          }
        ],

        selected_field_type: '文本',
        selected_can_edit_field_types: []

      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.dataList = JSON.parse(this.$route.params.dataList)
      this.headList = JSON.parse(this.$route.params.headList)
      this.import_data = this.$route.params.import_data

      this.transferList = []
      for (var i = 0; i < this.headList.length; i++) {
        let item = {
          key: this.headList[i].label,
          label: this.headList[i].label,
          disabled: false
        }
        this.transferList.push(item)
      }

      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      if (this.form_id) {
        this.form_name = this.$route.params.form_name
      }
    },
    methods: {
      nextStep() {
        let that = this

        if (Utils.isEmpty(this.form_name)) {
          this.$alert('请输入查询名称')
          return
        }

        if (this.selectedSearchCondition.length === 0) {
          this.message = '至少选一个查询条件,如姓名、工号、学号等(最多2个)'
          this.$alert(this.message)
          return
        }

        if (this.selectedSearchCondition.length > 2) {
          this.message = '不要超过2个查询条件(最多2个),否则录入会很困难,请重新选择！'
          this.$alert(this.message)
          return
        }

        if (this.selectedFields.length == 0) {
          this.message = '至少有一个列是可以让领表人修改或填写的，否则数据核对没有意义哦！'
          this.$alert(this.message)
          return
        }

        this.setConditionConfirmVisible = true

      },
      nextStepAction() {
        let that = this

        if (this.show_public) {
          that.is_public = '1'
        } else {
          that.is_public = '0'
        }

        var jsonConditionStr = JSON.stringify(that.selectedSearchCondition)
        var jsonSelectedFields = JSON.stringify(that.selectedFields)
        var jsonSelectedFieldTypes = JSON.stringify(that.selected_can_edit_field_types)

        var requestUrl = '/checking/web/_import_excel_form_data.jsp'

        let data = {
          username: that.username,
          form_name: that.form_name,
          head_list: JSON.stringify(that.headList),
          data_list: JSON.stringify(that.dataList),

          input_pages: that.input_pages,
          import_data: that.import_data,

          search_conditions: jsonConditionStr,
          public_condition: that.is_public,
          search_description: that.search_description,

          form_id: that.form_id,

          edit_fields: jsonSelectedFields,

          selected_can_edit_field_types: jsonSelectedFieldTypes
        }

        var qs = require('qs')

        const load = this.$loading({
          lock: true,
          text: '正在导入,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            that.$message({
              duration: 5000,
              message: '导入成功！如需修改，请在微信中用多人填表修改！',
              type: 'success'
            })
            load.close()

            if (that.import_data === '1') {
              that.$router.push({
                path: '/query_list',
                params: {
                  username: that.username
                }
              })
            }
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      back() {
        this.$router.back()
      },
      hasFixColumn() {
        let that = this
        var hasFixed = false

        for (var i = 0; i < that.headList.size(); i++) {
          let column = that.headList[i]
          if (column.can_edit == '0') {
            hasFixed = true
            break
          }
        }

        return hasFixed
      },
      showPublicTips() {
        let that = this
        this.finalConditions = []
        var tstr = ''

        for (var i = 0; i < that.selectedSearchCondition.length; i++) {
          var str = ''
          if (i === 0) {
            str = that.selectedSearchCondition[0]
            tstr = str
          } else {
            str = that.selectedSearchCondition[i]
            tstr = tstr + '、' + str
          }
        }

        if (tstr !== '') {
          tstr = '"' + tstr + '"'
        }

        var tempstr = '公开' + tstr + '条件的值,便于领表人选入查询条件(不涉及隐私时使用)'
        return tempstr
      },
      getTransferLabel(field_name) {
        var label = ''
        for (var i = 0; i < this.transferList.length; i++) {
          let obj = this.transferList[i]
          if (obj.key == field_name) {
            label = obj.label
            break
          }
        }
        return label
      },
      openEditFieldType(item) {
        this.selectedEditFieldName = item
        this.editFieldTypeDialogVisible = true
      },
      saveFieldTypeAction() {
        let field_name = this.selectedEditFieldName
        let field_type = this.selected_field_type

        var found = false

        for (var i = 0; i < this.selected_can_edit_field_types.length; i++) {
          let tempObj = this.selected_can_edit_field_types[i]
          if (tempObj.field_name == field_name) {
            this.selected_can_edit_field_types[i].field_type = this.selected_field_type
            found = true
            break
          }
        }

        if (!found) {
          let tmpObj = {
            field_name: this.selectedEditFieldName,
            field_type: this.selected_field_type
          }
          this.selected_can_edit_field_types.push(tmpObj)
        }

        this.editFieldTypeDialogVisible = false
      },
      getFieldType(field_name) {
        var field_type = '文本'

        for (var i = 0; i < this.selected_can_edit_field_types.length; i++) {
          let tempObj = this.selected_can_edit_field_types[i]
          if (tempObj.field_name == field_name) {
            field_type = this.selected_can_edit_field_types[i].field_type
            break
          }
        }

        return field_type
      }
    }
  }
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.main-layout {
  flex: 1;
  display: flex;
}

.sidebar {
  width: 220px;
  background: #fff;
  border-right: 1px solid #e8ecf1;
  flex-shrink: 0;
}

.content {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

/* 页面标题 */
.page-header {
  margin-bottom: 20px;
}

.page-title {
  font-size: 22px;
  color: #303133;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}

.page-title i {
  color: #1485FB;
}

.page-description {
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.page-description p {
  margin: 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
}

.page-description .highlight {
  color: #1485FB;
  font-weight: 600;
  font-size: 16px;
}

/* 设置容器 */
.setting-container {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

/* 步骤区块 */
.step-section {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e8ecf1;
}

.step-section:last-of-type {
  border-bottom: none;
  margin-bottom: 24px;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.step-number {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
}

.step-title {
  font-size: 18px;
  color: #303133;
  font-weight: 600;
}

.required {
  color: #f56c6c;
}

.step-content {
  padding-left: 44px;
}

.step-tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #1485FB;
  margin-bottom: 16px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.step-tip.warning {
  background: #fef0f0;
  border-left-color: #f56c6c;
  color: #f56c6c;
}

.step-tip i {
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 2px;
}

.text-danger {
  color: #f56c6c;
}

/* 表单输入 */
.form-name-input {
  max-width: 500px;
}

/* 穿梭框 */
.transfer-wrapper {
  display: flex;
  /* justify-content: center; */
  margin: 16px 0;
}

::v-deep .custom-transfer .el-transfer-panel {
  width: 260px;
}

::v-deep .custom-transfer .el-transfer-panel__list {
  height: 280px;
}

/* 已选预览 */
.selected-preview {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
}

.preview-title {
  display: flex;
  /* align-items: center; */
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
  /* justify-content: center; */
  text-align: center;
}

.preview-title i {
  color: #1485FB;
}

.preview-box {
  background: #f8f9fa;
  border: 1px solid #e8ecf1;
  border-radius: 6px;
  padding: 16px;
  width: 600px;
  max-width: 600px;
}

.preview-item {
  margin-bottom: 8px;
}

.preview-item-row {
  margin-bottom: 16px;
}

.preview-label {
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.preview-input input {
  width: 80%;
  height: 36px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 12px;
  background: #fff;
}

.preview-note {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.preview-error {
  color: #f56c6c;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 可填写列样式 */
.fields-box {
  max-width: 600px;
}

.field-item {
  padding: 12px;
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 4px;
  margin-bottom: 8px;
}

.field-item:last-child {
  margin-bottom: 0;
}

.field-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.field-name {
  font-weight: 600;
  color: #303133;
}

.field-type-edit {
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.field-type-edit:hover {
  color: #1485FB;
}

.field-type {
  color: #f56c6c;
  font-weight: 600;
  text-decoration: underline;
}

/* 提交按钮 */
.submit-section {
  /* text-align: center; */
  padding: 24px 0;
  margin-left:100px;
}

.submit-btn {
  padding: 14px 40px;
  font-size: 16px;
}

.submit-btn i {
  margin-right: 8px;
}

/* 弹窗样式 */
::v-deep .custom-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
  padding: 16px 20px;
}

::v-deep .custom-dialog .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.confirm-content {
  font-size: 15px;
  color: #606266;
  line-height: 1.8;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.confirm-content i {
  color: #e6a23c;
  font-size: 20px;
  flex-shrink: 0;
}

.confirm-content .highlight {
  color: #f56c6c;
  font-weight: 600;
}

.field-type-edit-form .form-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.field-type-edit-form .label {
  width: 100px;
  color: #606266;
  font-size: 14px;
}

.field-type-edit-form .value {
  color: #f56c6c;
  font-weight: 600;
  font-size: 15px;
}

.field-type-edit-form .type-select {
  flex: 1;
}

.dialog-footer {
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar {
    display: none;
  }

  .content {
    padding: 12px;
  }

  .page-title {
    font-size: 20px;
  }

  .setting-container {
    padding: 16px;
  }

  .step-content {
    padding-left: 0;
  }

  .step-header {
    flex-wrap: wrap;
  }

  .form-name-input {
    max-width: 100%;
  }

  .field-info {
    flex-direction: column;
    align-items: flex-start;
  }

  .submit-btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/excel_data_import_final_step.vue